export default "__VITE_ASSET__ad49bf73__"